// Estructura para WhatsApp

document.addEventListener('DOMContentLoaded', function() {
    
    // La función de esta parte es buscar el formulario y guardarlo
    // en la variable formulario para trabajar con él
    const formulario = document.getElementById('formWhatsApp');
    console.log('Formulario encontrado:', formulario);
    
    if (!formulario) {
        console.error('No se encontró el formulario');
        return;
    }
    
    // Escuchar clic en el botón
    formulario.addEventListener('submit', function(evento) {
        
        // Evita que la página recargue
        evento.preventDefault();
        console.log('Botón presionado');
        
        // Obtener los valores de cada campo
        // trim elimina los espacios al inicio y al final
        const nombre = document.getElementById('nombre').value.trim();
        const telefono = document.getElementById('telefono').value.trim();
        const correo = document.getElementById('correo').value.trim();
        const mensaje = document.getElementById('mensaje').value.trim();
        
        // Esta línea toma el número al que se va a enviar el mensaje
        // que es un input que está oculto
        const numeroWhatsApp = document.getElementById('numeroWhatsapp').value;
        
        // Mostrar en consola para verificar
        console.log('Datos:');
        console.log('Nombre:', nombre);
        console.log('Teléfono:', telefono);
        console.log('Correo:', correo);
        console.log('Mensaje:', mensaje);
        console.log('Número destino:', numeroWhatsApp);
        
        // VALIDACIONES
        
        // Validar: ¿Nombre tiene texto?
        if (nombre === '') {
            alert('Por favor ingresa tu nombre');
            document.getElementById('nombre').focus(); // Pone el cursor en nombre
            return; // Detiene la ejecución
        }
        
        // Validar: ¿Teléfono tiene contenido?
        if (telefono === '') {
            alert('El servicio es personalizado, por favor ingresa tu teléfono para que uno de nuestros asesores te contacte.');
            document.getElementById('telefono').focus();
            return; // Detiene la ejecución
        }
        
        // Validar: ¿El teléfono tiene al menos 10 dígitos?
        // .length es para comparar longitud
        if (telefono.length < 10) {
            alert('El teléfono debe tener al menos 10 dígitos');
            document.getElementById('telefono').focus();
            return;
        }
        
        console.log('Validación exitosa');
        
        // CONSTRUIR MENSAJE PARA WHATSAPP
        
        // El operador += en JavaScript es un operador de asignación de adición
        // que suma el operando derecho al izquierdo y asigna el resultado al
        // operando izquierdo. Es equivalente a escribir x = x + y
        
        // Las comillas invertidas ` ` son template literals de JavaScript
        // Un template es un modelo prediseñado que sirve como guía
        // Con las comillas invertidas, JavaScript puede insertar variables
        // dentro del texto usando ${...}
        
        // \n significa salto de línea
        // Los * no son JavaScript, son caracteres que WhatsApp interpreta como formato
        // WhatsApp utiliza *texto* para poner el texto en negritas
        
        let mensajeWhatsApp = `*Hola me interesa obtener mas informacion*
                                *Nombre:* ${nombre}
                                *Teléfono:* ${telefono}`;
        
        // Solo se agregan si fueron llenados
        if (correo) {
            mensajeWhatsApp += `\n*Correo:* ${correo}`;
        }
        
        // Solo agregar mensaje si fue agregado
        if (mensaje) {
            mensajeWhatsApp += `\n\n*Mensaje:*\n${mensaje}`;
        } else {
            mensajeWhatsApp += `\n\n*Mensaje:*\nEl cliente no dejó mensaje`;
        }
        
        console.log('Mensaje generado:');
        console.log(mensajeWhatsApp);
        
        // ENVIAR A WHATSAPP
        
        // Codificar mensaje para URL de WhatsApp
        const mensajeCodificado = encodeURIComponent(mensajeWhatsApp);
        console.log('Mensaje codificado:', mensajeCodificado);
        
        // Construir URL de WhatsApp
        const urlWhatsApp = `https://api.whatsapp.com/send?phone=${numeroWhatsApp}&text=${mensajeCodificado}`;
        console.log('URL final:', urlWhatsApp);
        
        // Abrir WhatsApp en una nueva pestaña
        window.open(urlWhatsApp, '_blank');
        
        // Limpiar formulario
        formulario.reset();
        
    });
    
});


// ============================================
        // FAQ - ACORDEÓN
        // ============================================
        document.addEventListener('DOMContentLoaded', function() {
            const preguntas = document.querySelectorAll('.faq__pregunta');

            preguntas.forEach(pregunta => {
                pregunta.addEventListener('click', function() {
                    const item = this.closest('.faq__item');
                    const isActive = item.classList.contains('active');

                    document.querySelectorAll('.faq__item.active').forEach(el => {
                        if (el !== item) {
                            el.classList.remove('active');
                        }
                    });

                    if (isActive) {
                        item.classList.remove('active');
                    } else {
                        item.classList.add('active');
                    }
                });
            });
        });

       /**
 * ============================================
 * ANIMACIÓN DE TARJETAS AL HACER SCROLL
 * ============================================
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Selecciona todas las tarjetas de servicio
    const cards = document.querySelectorAll('.servicio-card');
    
    if (!cards.length) return;
    
    // Configuración del observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
    });
    
    // Observar cada tarjeta
    cards.forEach(card => {
        observer.observe(card);
    });
    
});


 // ============================================
        // ANIMACIÓN DE CONTADOR PARA MÉTRICAS
        // ============================================
        document.addEventListener('DOMContentLoaded', function() {
            const numeros = document.querySelectorAll('.metricas__numero');
            
            const animarContador = (elemento) => {
                const objetivo = parseInt(elemento.dataset.contador);
                const incremento = Math.ceil(objetivo / 40);
                let actual = 0;
                
                const intervalo = setInterval(() => {
                    actual += incremento;
                    if (actual >= objetivo) {
                        actual = objetivo;
                        clearInterval(intervalo);
                    }
                    elemento.textContent = actual + (elemento.dataset.contador === '98' ? '%' : '');
                }, 30);
            };
            
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const numeros = entry.target.querySelectorAll('.metricas__numero');
                        numeros.forEach(num => animarContador(num));
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.3 });
            
            const metricas = document.querySelector('.metricas');
            if (metricas) observer.observe(metricas);
        });